import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { TooltipModule } from 'primeng/tooltip';
import { ComponentsModule } from 'app/main/apps/components/components.module';

import { AccountMenuComponent } from './account-menu/account-menu.component';
import { AppLayoutComponent } from './app.layout.component';
import { ChangeOrganizationModalComponent } from './change-organization-modal/change-organization-modal.component';
import { FreeTrialCardComponent } from './free-trial-card/free-trial-card.component';
import { MobileTopbarComponent } from './mobile-topbar/mobile-topbar.component';
import { NavListComponent } from './nav-list/nav-list.component';
import { FaqComponent } from './need-help-modal/faq/faq.component';
import { NeedHelpModalComponent } from './need-help-modal/need-help-modal.component';
import { ShellComponent } from './shell/shell.component';
import { SidebarComponent } from './sidebar/sidebar.component';

@NgModule({
    declarations: [
        AccountMenuComponent,
        AppLayoutComponent,
        ChangeOrganizationModalComponent,
        FaqComponent,
        FreeTrialCardComponent,
        MobileTopbarComponent,
        NavListComponent,
        NeedHelpModalComponent,
        ShellComponent,
        SidebarComponent,
    ],
    imports: [
        CommonModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        // PrimeNG modules
        AccordionModule,
        ButtonModule,
        InputTextModule,
        MenuModule,
        SkeletonModule,
        TableModule,
        TagModule,
        TextareaModule,
        TooltipModule,
    ],
    // The shell is exported for the theme style board, which previews it with sample data.
    exports: [ShellComponent],
})
export class AppLayoutModule {}
